"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _theme_1 = require("@theme");
const _store_1 = __importDefault(require("@store")); // Component
var AccountWelcome = function AccountWelcome() {
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.signOut;
    }), user = _useGlobal[0];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal2[1];
    var skip = function skip() {
        return setVisibleDropdown(undefined);
    };
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        orderReverse: true,
        alignCenter: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, {
        noPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Nice to see you"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Welcome back, ", user === null || user === void 0 ? void 0 : user.firstName), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "There are lots of great new articles to explore in PRIOR\u2019s ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/inspiration",
        onClick: function onClick() {
            return skip();
        }
    }, "Inspiration"), " and ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/experiences",
        onClick: function onClick() {
            return skip();
        }
    }, "Experiences"), ". You can also ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "#",
        onClick: function onClick() {
            return skip();
        }
    }, "skip for now"), ". "), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        to: "/account",
        size: "large",
        shadow: true
    }, "View Profile")))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.StyledImage, {
        src: "/images/accounts/welcome.png",
        objectFit: "contain"
    })));
}; // Styling
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "AccountWelcomeBack__StyledLink",
    componentId: "sc-113v8xx-0"
})(["color:", ";"], _theme_1.palette.brown);
exports.default = AccountWelcome;
